import React, { useState, useEffect, useRef } from 'react';
import serverConf from "config/server.config";

function Tile({
  image,
  avatar,
  name,
  description,
  tags,
  gameId
}) {
  const [imageUrl, setImageUrl] = useState('https://via.placeholder.com/1024x640');
  const [truncatedDescription, setTruncatedDescription] = useState(description);
  const descriptionRef = useRef(null);

  useEffect(() => {
    setImageUrl(`${serverConf.HOST}/image/${image}`);
  }, [image]);

  useEffect(() => {
    const element = descriptionRef.current;
    if (element.scrollHeight > element.clientHeight) {
      let truncated = description;
      while (element.scrollHeight > element.clientHeight && truncated.length > 0) {
        truncated = truncated.slice(0, -1);
        element.innerText = truncated + '...';
      }
      setTruncatedDescription(truncated + '...');
    }
  }, [description]);

  return (
    <div className="w-full max-w-full rounded-xl border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800 hover:shadow-2xl hover:scale-[1.02] transition-all duration-300">
      <div className="w-full">
        <a href={`/play/${gameId}`}>
          <img className="h-full w-full object-cover rounded-t-xl" src={imageUrl} alt={name} />
        </a>
      </div>
      <div className="p-6">
        <a
          href={`/play/${gameId}`}
          className="text-2xl font-bold leading-tight text-gray-900 hover:text-pink-500 dark:text-white dark:hover:text-pink-400 transition-colors"
        >
          {name}
        </a>

        <ul className="mt-3 flex flex-wrap items-center gap-2">
          {tags.slice(0, 4).map((tag, index) => (
            <li key={index} className="flex items-center gap-2">
              <p className="text-xs font-semibold px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-md">{tag}</p>
            </li>
          ))}
        </ul>

        <p
          ref={descriptionRef}
          className="mt-4 text-sm text-gray-600 dark:text-gray-400 leading-relaxed"
          style={{ height: '8em', overflow: 'hidden' }}
        >
          {truncatedDescription}
        </p>

        <div className="mt-4 flex items-center justify-between gap-4">
          <a href={`/play/${gameId}`}>
            <button
              type="button"
              className="inline-flex items-center rounded-lg bg-gradient-to-r from-sky-400 to-blue-500 hover:from-sky-500 hover:to-blue-600 px-4 py-2 text-sm font-bold text-white shadow-md hover:shadow-lg transition-all"
            >
              <i className="fas fa-comment mr-2"></i>
              Chat Mode
            </button>
          </a>
          <a href={`/story/${gameId}`}>
            <button
              type="button"
              className="inline-flex items-center rounded-lg bg-gradient-to-r from-purple-400 to-indigo-500 hover:from-purple-500 hover:to-indigo-600 px-4 py-2 text-sm font-bold text-white shadow-md hover:shadow-lg transition-all"
            >
              <i className="fas fa-pencil mr-2"></i>
              Story Mode
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Tile;